<template functional>
    <div>
        <div class="underlined">
            <h1>
                {{ props.title }}
            </h1>
        </div>
        <div>
            <slot>
                <p>
                    Dolor voluptatibus est enim est ab temporibus qui. Ut molestias exercitationem error. Velit ad
                    doloribus inventore itaque sed rem rerum sint. Inventore ut quis vel ullam recusandae ab tempora.
                    Sit numquam illum et non beatae reprehenderit quia. Impedit soluta odit distinctio qui et nihil.
                </p>
                <p>
                    Aut et et repudiandae exercitationem. Minus debitis delectus sit laborum numquam nihil tenetur. Quos
                    possimus molestiae et quia commodi optio quod repudiandae. Quae delectus perspiciatis ad sit
                    expedita fuga cupiditate voluptatem. Explicabo eius optio quia deleniti rerum explicabo iusto.
                    Assumenda molestiae at nam aut illo ullam officiis qui.
                </p>
                <p>
                    Laboriosam magnam et architecto dolores expedita quae. Aut error ut sint sed. Omnis in molestiae eum
                    veniam.
                </p>
                <p>
                    Fugit consequuntur voluptatem modi pariatur nemo sapiente et. Expedita et quia exercitationem. Saepe
                    quia et sit itaque omnis quaerat. Debitis et labore sapiente eum nobis. Error iste aut eius eos.
                    Voluptatibus illum ab saepe explicabo quia asperiores animi.
                </p>
                <p>
                    Commodi et beatae debitis accusamus ratione quaerat. Omnis qui ad iusto necessitatibus est
                    laudantium
                    dolorum omnis. Provident quaerat aut perferendis consequatur porro quam ab deserunt.
                </p>
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: 'Title'
            }
        }
    }
</script>


<style lang="scss" scoped>
    .underlined {
        border-bottom: 1px solid dimgrey;
    }
</style>
